import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatNumberWithCommas',
  standalone: true,
})
export class FormatNumberWithCommasPipe implements PipeTransform {
  transform(value: string | number, sign: string = ','): string {
    if (value == null || value === '') return '';

    const number = Number(value.toString().replace(/,/g, ''));

    if (isNaN(number)) return '';

    return number.toLocaleString('en-US').replace(/,/g, sign);
  }
}
